import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import config from '../../../config';
import { history } from '../../../routes';
import { ToastContainer, notify } from '../../../libraries/notifications';
import FormLayout from '../../../components/forms/FormLayout';
import settingActions from '../../../context/settings/actions';
import companyActions from '../../../context/companies/actions';
import LayoutWithSidebar from '../../../components/layout/LayoutWithSidebar';
import PanelWindow from '../../../components/PanelWindow';
import { getOwner } from '../../../libraries/utils';
import prizesActions from '../../../context/benefits/actions';
import actions from '../../../context/transactions/actions';
import ItemSettings from './ItemsSetting';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      defaultSettings: [],
      loading: false,
      submitting: false,
      view: false,
      editing: false,
      settings: [],
      titles: '',
      type: '',
      owner: '',
      remove: false,
      optionPrizes: []
    };
    this.submit = null;
    this.reset = null;
    this.breadcrumbs = [this.t('Settings'), this.t('New')];
    this.titles = this.t('User details');
  }

  // ** Life cycle
  componentDidMount() {
    this.setState({
      remove: true,
      view: true,
      titles: this.t('Edit Settings')
    });
    this.breadcrumbs = [this.t('Settings'), this.t('Edit')];
    this.getDefaultSettings();
     if(this.props.auth.user.type.includes('companies')) this.getPrizes();
   }

  getDefaultSettings = async () => {
    const { user } = this.props.auth;
    const type = user.roles.includes(config.ROLES.COMPANIES)
      ? config.TYPES.SETTINGS.SHARYCO_SETTINGS
      : user.roles.includes(config.ROLES.ADMIN)
      ? config.TYPES.SETTINGS.SHARYCO_ADMIN_SETTINGS
        : null;
    this.setState({ type: type });
    const params = {
      type: type,
      owner: config.OWNER.SYSTEM
    };
    this.setState({ loading: true });
    await this.props.onGetSettings(params);
    const { settings } = this.props;
    if (settings.error) {
      notify(this.t(settings.error.message));
    } else if (user.roles.includes(config.ROLES.COMPANIES)) {
      const companyParams = {
        owner: getOwner(this.props.auth.user)
      };
      await this.props.onGetCompanies(companyParams);
      const { companies } = this.props;
      if (companies.error) {
        notify(this.t(companies.error.message));
      } else {
        this.setState({ defaultSettings: settings.items, owner: companies?.items[0].id }, () =>
          this.getSettings(params)
        );
      }
    } else if (user.roles.includes(config.ROLES.ADMIN)) {
      this.setState({ defaultSettings: settings.items, owner: config.OWNER.SYSTEM }, () => this.getSettings(params));
    }
  };

  getSettings = async params => {
    const { defaultSettings, owner } = this.state;
    params.owner = owner;
    await this.props.onGetSettings(params);

    const { settings } = this.props;
    if (settings.error) {
      notify(this.t(settings.error.message));
    } else {
      console.log("settings", settings.items)
      this.setState({ settings: settings.items, loading: false }, () => {
        if ( this.state.defaultSettings.length) {
          let finalArr = this.state.settings;
          for (let i = 0; i < defaultSettings.length; i++) {
          const indx= this.state.settings.findIndex(s=>s.name===defaultSettings[i].name&&s.code===defaultSettings[i].code)
          if(indx < 0){
            finalArr.push({
              name: defaultSettings[i].name,
              details: defaultSettings[i].details,
              value: defaultSettings[i].value,
              code: defaultSettings[i].code,
              type: defaultSettings[i].type,
              optionsValue:defaultSettings[i].optionsValue,
              data_type: defaultSettings[i].data_type,
              scope: defaultSettings[i].scope,
              setting_group: defaultSettings[i].setting_group,
              owner: defaultSettings[i].owner,
            })
          }
            if (i === defaultSettings.length - 1) {
              this.setState({
                settings: [...finalArr],
                loading: false
              });
            }
          }
        }
      });
    }
  };

  getCompanies = async () => {
    //await this.props.onGetCompanies({ owner: this.props.auth.user.id });
    await this.props.onGetCompanies({ owner: getOwner(this.props.auth.user) });

    if (this.props.companies.error) {
      notify(this.t(this.props.companies.error.messsage));
    } else {
      return this.props.companies.items
    }
  };

  getPrizeUses = async id => {
    this.setState({ loading: true });
    let params = {
      target: id,
      type: config.TRANSACTIONS.BENEFIT.TYPE,
      owner: this.props.auth.user.unique_id,
    };
    await this.props.onGetTransactions(params);
    const { items, error } = this.props.transactions;
    if (error) return null
    return items
  }

  getPrizes = async () => { 
    const owner = await this.getCompanies();
    const params = { owner: owner[0]?.id, type: config.TYPES.BENEFITS.PRIZE };
 
    await this.props.onGetAllPrizes(params);
    const { prizes } = this.props;
    if (prizes.error) {
      notify(this.t(prizes.error.message));
    } else {
      const transactionPrizez = await Promise.all(prizes.items.map(async (p) => (await this.getPrizeUses(p.id))))
      const prizesWithCountTransaction = prizes?.items.map((p,i) =>({...p,transactionCount:transactionPrizez[i]?.filter(t => t.status === 'consumed').length||0}) )
      const premiosDisponibles=prizesWithCountTransaction.filter(p=>p?.json_data?.rules?.group_uses-p.transactionCount>0)
      const optionPrizes = premiosDisponibles?.map(p=>({ value: p.id, label: this.props.t(p.name)}))
      optionPrizes.unshift({ value:0, label: this.props.t("Seleccionar...")});
      this.setState({ prizes:prizesWithCountTransaction, optionPrizes, loading: false });}
  };


  componentWillUnmount() {
    this.props.onClearCurrent();
  }

  gotoBack = action => {
    if (!this.props.location.state) {
      history.push(config.ROUTES.SETTINGS);
    } else {
      const { location, from } = this.props.location.state;
      if (from === config.ROUTES.BOOK.SETTING) {
        history.push({
          pathname: action ? config.ROUTES.BOOK.SERVICE : config.ROUTES.BOOK.SETTING,
          state: {
            location,
            action: action || undefined
          }
        });
      } else {
        history.push(config.ROUTES.SETTINGS);
      }
    }
  };

  onSubmit = async values => {
    this.setState({loading: true})
    const localSettings = this.state.settings;
    const { owner } = this.state;
   
    for (let obj of localSettings) {
      obj.value = values[obj.code];
    }
    for (let i = 0; i < localSettings.length; i++) {
      const element = { ...localSettings[i], owner: owner };
      await this.props.onSaveOrUpdate({
        ...element,
      });
    }
    const settings = this.props.settings;
    if (settings.error) {
      notify(this.t(settings.error.message));
    } else {
      this.setState({ editing: false });
      const params = {type: this.state.type, owner: this.state.owner}
      this.getSettings(params);
    }
  };

  render() {
    // **Destructuring objects for direct use of values
    const { view, editing, submitting, settings, loading } = this.state;
    const { user } = this.props.auth;

    // Layout settings
    const actions = {
      main: {
        onClick: e => this.submit(e),
        title: this.t('Save'),
        icon: 'checkmark',
        disabled: submitting || (view && !editing),
        checkPermissions: 'insert'
      },
      secondaries: [
        {
          onClick: e => this.setState({ editing: true }),
          title: this.t('Edit'),
          icon: 'edit_pencil',
          disabled: submitting,
          visible: view && !editing,
          checkPermissions: 'update'
        },
        {
          onClick: e => {
            this.reset();
            this.setState({ editing: false });
          },
          title: this.t('Cancel'),
          icon: 'edit_pencil',
          disabled: submitting || !editing,
          visible: editing
        }
      ]
    };

    const customFormObject = {};
    const detailsDisplayObject = {};

    // {details: setting.details, label: setting.name}
    // customFormObject[setting.code]

    if (user.roles.includes(config.ROLES.COMPANIES) && settings.length > 0) {
      settings?.forEach(setting => {
        if(setting.code == 'prize_by_company'  || setting.code == 'time_del_action'){
          customFormObject[setting.code] = setting.value;
          detailsDisplayObject[setting.code] = setting.details || '';
          return;
        }else{
          customFormObject[setting.code] = setting.value === 'true' ? true : setting.value === 'false' ? false : true;
          detailsDisplayObject[setting.code] = setting.details || '';
          return;
        }
      });
    }

    if (user.roles.includes(config.ROLES.ADMIN) && settings.length > 0) {
      settings?.forEach(setting => {
        customFormObject[setting.code] = setting.value;
        detailsDisplayObject[setting.code] = setting.details || '';
        return;
      });
    }

    const groupBySettingGroup = settings.reduce((acc, setting) => {
      const group = setting.setting_group || 'default';
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(setting);
      return acc;
    }, {});

    // ** Actual render
    return (
      <LayoutWithSidebar
        main={{ className: 'text-content-400' }}
        header={{
          breadcrumbs: this.breadcrumbs
        }}
        container={{ className: 'px-8' }}
        actions={actions}>
        <ToastContainer />
        <PanelWindow outterTitle={this.titles} loading={loading}>
          <Form  initialValues={customFormObject || {}} onSubmit={this.onSubmit}>
            {({ handleSubmit, form, submitting, pristine, values }) => {
              this.submit = handleSubmit;
              this.reset = form.reset;
              return (
                <FormLayout form={form} onSubmit={this.onSubmit} values={values}>
                  {(
                    <>
                    {
                      Object.keys(groupBySettingGroup).sort((a,b)=>a.localeCompare(b)).map(group => {
                        const settingsFilter= groupBySettingGroup[group] .filter(setting => {
                          const isAdmin =  user.roles.includes(config.ROLES.ADMIN)
                          if(isAdmin) return isAdmin && setting.type == "sharyco_admin_settings"
                          return (setting?.scope?.includes("user") || setting.scope == "" || setting.scope== null) && !isAdmin
                        })
                        return (
                        <div key={group} className="w-full px-3 mb-3 md:mb-0 mt-3">
                          {Object.keys(settingsFilter)?.length > 0 &&  <h1 className='text-base font-bold'>{group?.toUpperCase()}</h1>}
                          {settingsFilter
                        .sort((a,b)=>new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
                        .map((setting,i) => {
                        let optionSelect= null;
                        if(setting.code == "prize_by_company") optionSelect = this.state.optionPrizes;
                        return <div>
                          <ItemSettings key={setting.id} setting={setting} view={view} editing={editing} options={optionSelect}/>
                        </div>
                        })}
                        </div>
                      )}
                    )
                    }
                    </>
                  )}
                </FormLayout>
              );
            }}
          </Form>
          <pre>
            {/* {JSON.stringify(groupBySettingGroup, null, 2)} */}
          </pre>
        </PanelWindow>
      </LayoutWithSidebar>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    companies: state.companies.list,
    settings: state.settings.list,
    prizes: state.benefits.list,
    transactions: state.transactions.list

  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSaveOrUpdate: params => dispatch(settingActions.saveOrUpdate(params)),
    onGetSettings: params => dispatch(settingActions.getAll(params)),
    onGetCompanies: params => dispatch(companyActions.getAll(params)),
    onRemove: id => dispatch(settingActions.del(id)),
    onClearCurrent: () => dispatch(settingActions.clearCurrent()),
    onGetAllPrizes: params => dispatch(prizesActions.getAll(params)),
    onGetTransactions: params => dispatch(actions.getAll(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Settings));